import { useQuery } from '@tanstack/react-query';
import { menuApi } from '../api/menuApi';

/**
 * GET /api/eraf/menus/{id} — 메뉴 단건 상세
 * queryKey: ['menu-management', 'detail', id]
 */
export function useMenuDetail(id: number | null | undefined) {
  return useQuery({
    queryKey: ['menu-management', 'detail', id],
    queryFn: () => menuApi.getById(id!),
    enabled: id != null,
    staleTime: 30_000,
  });
}
